<template>
  <div v-if="record.agreement">
    <strong>Agreement Hierarchy for {{ record.agreement.doc_id }}</strong>
    <svg id="tree" ref="tree" width="250" height="325">
      <g :transform="translate">
        <path class="agreement" :d="path"></path>
        <template v-for="node in nodes">
          <circle v-bind:key="node.data.id" id="show-modal" @click="loadAgreement(node)" v-bind:class="{ 'current': node.isCurrent, 'active': node.isActive }" r="5" :cx="node.x"
                  :cy="node.y"></circle>
          <text v-bind:key="node.data.id" class="agreement" v-bind:class="{ current: node.isCurrent, active: node.isActive }" :x="node.x + 7"
                :y="node.y + 3" @click="loadAgreement(node)">{{ node.data.id }}
          </text>
        </template>
      </g>
    </svg>
    <agreement-modal v-if="showModal" @close="showModal = false">
      <!--
        you can use custom content here to overwrite
        default content
      -->
      <h3 slot="header">{{ agreement.agreement_filename }}</h3>
    </agreement-modal>
  </div>
</template>

<script>
import * as d3 from "d3";
import { mapState } from "vuex";
import AgreementModal from "./AgreementModal";

export default {
  name: "record-hierarchy",
  computed: mapState(["agreement", "record"]),
  components: { AgreementModal },
  data() {
    return {
      height: 300,
      width: 200,
      translate: "translate(-30,40)",
      paths: [],
      path: "",
      nodes: [],
      root: {},
      showModal: false
    };
  },
  watch: {
    record: function() {
      this.getTree();
    }
  },
  mounted() {
    this.getTree();
  },
  methods: {
    getTree() {
      if (this.record.agreement === undefined) {
        return;
      }
      this.paths = [];
      this.path = "";
      this.nodes = [];
      const tree = d3.cluster().size([this.height, this.width]);
      const treeData = d3
        .stratify()
        .id(function(d) {
          return d.name;
        })
        .parentId(function(d) {
          return d.parent;
        })(this.record.agreement.tree);

      this.root = d3.hierarchy(treeData);
      var p = this;
      tree(this.root).each(function(node) {
        if (node.data.id === p.record.agreement.doc_id.toString()) {
          p.$set(node, "isCurrent", true);
        } else {
          p.$set(node, "isCurrent", false);
        }
        p.nodes.push(node);
      });

      for (let link of tree(this.root).links()) {
        this.paths.push({
          x: link.source.x,
          y: link.source.y
        });
        this.paths.push({
          x: link.target.x,
          y: link.target.y
        });
      }
      const path = d3
        .line()
        .x(d => d.x)
        .y(d => d.y);
      this.path = path(this.paths);
    },
    loadAgreement(node) {
      for (let n of this.nodes) {
        this.$set(n, "isActive", false);
      }
      this.$set(node, "isActive", true);
      this.$store.dispatch("embedReady", false);
      this.$store.dispatch("embedLoading", true);
      let self = this;
      this.$store
        .dispatch("loadAgreement", {
          id: node.data.id
        })
        .then(
          function() {
            self.showModal = true;
          },
          error => {
            console.log(error);
            self.showModal = false;
          }
        );
    }
  }
};
</script>

<style>
circle.agreement {
  fill: #999;
  cursor: pointer;
}

circle.active {
  fill: #00cd00;
}

circle.current {
  fill: #4596e8;
}
text.agreement {
  font: 10px sans-serif;
  stroke: #999;
  cursor: pointer;
}
text.active {
  stroke: #999999;
}
path.agreement {
  fill: none;
  stroke: #555;
  stroke-opacity: 0.4;
  stroke-width: 1.5px;
}
</style>
